import { render, staticRenderFns } from "./ModalChangePassword.vue?vue&type=template&id=088177dc&scoped=true&"
import script from "./ModalChangePassword.vue?vue&type=script&lang=js&"
export * from "./ModalChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./ModalChangePassword.vue?vue&type=style&index=0&id=088177dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088177dc",
  null
  
)

export default component.exports